import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';
import ThemeToggle from './ThemeToggle';
import ayaLogo from './assets/aya-logo.png';

// Même règle que dans api.js : chemin relatif en production, adresse complète
// en développement. Sans cela, l'adresse « localhost » serait figée dans le
// build et personne d'autre que le développeur ne pourrait se connecter.
const API_URL =
  process.env.NODE_ENV === 'production'
    ? '/api'
    : process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [aide, setAide] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/login`, { username, password });

      const userData = {
        id: response.data.id,
        username: response.data.username,
        role: response.data.role,
        token: response.data.token,
      };

      // sessionStorage (et non localStorage) : la session est effacée dès que
      // l'onglet est fermé. L'utilisateur doit alors se reconnecter — c'est
      // volontaire, l'application contient des données d'entreprise et peut
      // être ouverte depuis un poste partagé.
      sessionStorage.setItem('user', JSON.stringify(userData));
      sessionStorage.setItem('token', userData.token);
      onLogin(userData);
    } catch (err) {
      if (!err.response) {
        setError('Serveur injoignable. Réessayez dans un instant.');
      } else if (err.response.status === 401) {
        setError('Identifiant ou mot de passe incorrect.');
      } else {
        setError(err.response?.data?.message || 'Connexion impossible. Réessayez.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-theme"><ThemeToggle /></div>
      <div className="login-box">
        <div className="login-header">
          <img src={ayaLogo} className="login-logo" alt="AYA Gold & Silver" />
          <div className="login-title">VIGIE</div>
          <div className="login-subtitle">
            Gestion des projets Usines Zgounder &mdash; Aya Gold &amp; Silver
          </div>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Identifiant</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 14 }}>
          <span
            style={{ fontSize: 12.5, color: 'var(--secondary, #517997)', cursor: 'pointer' }}
            onClick={() => setAide(!aide)}
          >
            Mot de passe oublié ?
          </span>
        </div>

        {aide && (
          <div
            style={{
              marginTop: 12,
              padding: '12px 14px',
              background: 'rgba(81,121,151,0.08)',
              border: '1px solid var(--border, #E4E8EE)',
              borderRadius: 8,
              fontSize: 12.5,
              lineHeight: 1.6,
              color: 'var(--text-secondary, #5C7085)',
            }}
          >
            Contactez un <strong>administrateur</strong> ou votre <strong>chef de projet</strong> :
            ils peuvent vous attribuer un nouveau mot de passe depuis la page Accès.
            <br />
            Pensez ensuite à le changer depuis votre profil.
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
